import * as actionTypes from "../actionTypes.js";

/**
 * Normalise the subscription object returned from the backend so the rest of
 * the frontend can always access:
 *   user.subscription.plan.slug   — e.g. 'basic' | 'pro' | 'pro-plus'
 *   user.subscription.plan.name
 *   user.subscription.plan.max_notes
 *   user.subscription.plan.payment_type
 *   user.subscription.status      — 'active' | 'past_due' | 'cancelled' | 'expired'
 *   user.subscription.payment_failed   — boolean
 *   user.subscription.payment_failure_reason — string | null
 *
 * The backend used to return flat plan_slug / plan_name / max_notes fields.
 * This normaliser handles both the old flat shape and the new nested shape.
 */
function normaliseSubscription(raw) {
  if (!raw) return raw;
  // Already normalised (has .plan as an object)
  if (raw.plan && typeof raw.plan === 'object') return raw;
  // Legacy flat shape — convert to nested
  return {
    ...raw,
    plan: {
      slug:         raw.plan_slug  || 'basic',
      name:         raw.plan_name  || 'Basic',
      max_notes:    raw.max_notes  ?? 3,
      payment_type: raw.payment_type || 'free',
    },
    payment_failed:          raw.payment_failed          ?? false,
    payment_failure_reason:  raw.payment_failure_reason  ?? null,
  };
}

const initialState = {
  isAuthenticated: false,
  user: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOG_IN:
      localStorage.setItem("user", JSON.stringify(action.payload.access));
      localStorage.setItem("refresh_token", JSON.stringify(action.payload.refresh));
      return {
        ...state,
        isAuthenticated: true,
        user: {
          ...action.payload.user,
          subscription: normaliseSubscription(action.payload.user?.subscription),
        },
      };

    case actionTypes.REFRESH_TOKEN:
      localStorage.setItem("user", JSON.stringify(action.payload.access));
      if (action.payload.refresh) {
        localStorage.setItem("refresh_token", JSON.stringify(action.payload.refresh));
      }
      return { ...state, isAuthenticated: true };

    case actionTypes.UPDATE_SUBSCRIPTION:
      return {
        ...state,
        user: state.user
          ? { ...state.user, subscription: normaliseSubscription(action.payload) }
          : state.user,
      };

    case actionTypes.LOG_OUT:
      localStorage.removeItem("user");
      localStorage.removeItem("refresh_token");
      return initialState;

    default:
      return state;
  }
};

export default authReducer;

